import { ApolloClient, gql } from 'apollo-boost';

const mutation = gql`
  mutation updateReport(
    $reportId: Int!
    $programId: Int
    $version: String
  ) {
    updateReport(id: $reportId, programId: $programId, version: $version) {
      success
    }
  }
`;

export const changeReportProgram = (
  client: ApolloClient<object>,
  reportId: number | string,
  programId: number,
) => {
  return client.mutate({
    mutation: mutation,
    variables: {
      reportId,
      programId,
    },
    fetchPolicy: 'no-cache',
  });
};
